import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { MerchSizes } from './constants';
import { buildMerchStoreConfig } from '../storeAliasHelper';
import { data_STAGING } from './STAGING';

export const CyborgClassicTshirtWhiteProduct = {
  title: 'Cyborg Classic White T-shirt',
  description: '100% organic Supima cotton. Made carbon neutral.',
  imgSrc: 'web_v2/all-products/merch/new/cyborg-classic-tee-white.png/w_1920',
  tag: 'popular',
  shopifyProductName: 'Cyborg Classic T-shirt',
  availableSizes: [
    MerchSizes.XS,
    MerchSizes.S,
    MerchSizes.M,
    MerchSizes.L,
    MerchSizes.XL,
    MerchSizes.XXL,
  ],
};

export const CyborgClassicTshirtWhiteShopifyMap: Record<
  ShopifyStore,
  {
    price: number;
    sizes: Record<MerchSizes, { variantId: string; checkoutUrl: string }>;
  }
> =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? buildMerchStoreConfig<MerchSizes>({
        [ShopifyStore.AE]: {
          price: 110,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/44691321094386',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691321094386:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/44691321159922',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691321159922:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/44691321225458',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691321225458:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/44691321290994',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691321290994:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/44691321356530',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691321356530:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/44691321422066',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691321422066:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.US]: {
          price: 30,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/40200408629344',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200408629344:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40200408694880',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200408694880:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40200408760416',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200408760416:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40200408825952',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200408825952:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40200408891488',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200408891488:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40200408957024',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200408957024:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.ROW]: {
          price: 30,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/40718619574332',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718619574332:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40718619607100',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718619607100:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40718619639868',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718619639868:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40718619672636',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718619672636:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40718619705404',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718619705404:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40718619738172',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718619738172:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.IN]: {
          price: 1699,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/40737950302278',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737950302278:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40737910227014',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737910227014:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40737910292550',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737910292550:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40737910358086',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737910358086:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40737910423622',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737910423622:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40737910489158',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737910489158:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.EU]: {
          price: 28,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/49202718015806',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202718015806:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/49202718081342',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202718081342:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/49202718146878',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202718146878:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/49202718212414',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202718212414:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/49202718277950',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202718277950:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/49202718343486',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202718343486:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.GB]: {
          price: 25,
        },
        [ShopifyStore.AU]: {
          price: 45,
        },
        [ShopifyStore.CA]: {
          price: 42,
        },
        [ShopifyStore.MX]: {
          price: 640,
        },
        [ShopifyStore.SA]: {
          price: 129,
        },
        [ShopifyStore.ZA]: {
          price: 599,
        },
        [ShopifyStore.JP]: {
          price: 4800,
        },
      })
    : data_STAGING;
